import { render, staticRenderFns } from "./NodeEditTree.vue?vue&type=template&id=dcdc244a&scoped=true"
import script from "./NodeEditTree.vue?vue&type=script&lang=js"
export * from "./NodeEditTree.vue?vue&type=script&lang=js"
import style0 from "./NodeEditTree.vue?vue&type=style&index=0&id=dcdc244a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcdc244a",
  null
  
)

export default component.exports